import { coinbaseWallet, injected, metaMask } from "@wagmi/connectors";
import { createConfig, http } from "wagmi";
import { cronos, kava, mainnet } from "wagmi/chains";

// Kava is the primary chain - others are included only for chain switching
export const kavaChain = {
  ...kava,
  id: 2222,
  name: "Kava",
  nativeCurrency: {
    decimals: 18,
    name: "Kava",
    symbol: "KAVA",
  },
  rpcUrls: {
    default: { http: ["https://evm.kava.io"] },
    public: { http: ["https://evm.kava.io"] },
  },
  blockExplorers: {
    default: { name: "Kava Explorer", url: "https://explorer.kava.io" },
  },
};

export const config = createConfig({
  chains: [kavaChain, cronos, mainnet], // Include other chains for switching
  connectors: [
    injected(),
    metaMask(),
    coinbaseWallet({ appName: "Scrub Money" }),
  ],
  transports: {
    [kavaChain.id]: http(),
    [cronos.id]: http(),
    [mainnet.id]: http(),
  },
  ssr: false,
});

declare module "wagmi" {
  interface Register {
    config: typeof config;
  }
}
